import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpGlobalDomainOptionsFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpOperatorRoleDefaultsFactory } from "./ExpOperatorRoleDefaults";

/**
 * 
 * @export
 * @interface ExpGlobalDomainOptions
 */

export class ExpGlobalDomainOptionsFactory {}
_ExpGlobalDomainOptionsFactory = ExpGlobalDomainOptionsFactory;
_defineProperty(ExpGlobalDomainOptionsFactory, "FromJSON", function (json) {
  return _ExpGlobalDomainOptionsFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpGlobalDomainOptionsFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'sourceOperandName': json['sourceOperandName'],
    'operatorRoleDefaults': json['operatorRoleDefaults'] === null || json['operatorRoleDefaults'] === undefined ? json['operatorRoleDefaults'] : json['operatorRoleDefaults'].map(ExpOperatorRoleDefaultsFactory.FromJSON)
  };
});
_defineProperty(ExpGlobalDomainOptionsFactory, "ToJSON", function (value) {
  return _ExpGlobalDomainOptionsFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpGlobalDomainOptionsFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'sourceOperandName': value.sourceOperandName,
    'operatorRoleDefaults': value.operatorRoleDefaults === undefined ? undefined : value.operatorRoleDefaults.map(ExpOperatorRoleDefaultsFactory.ToJSON)
  };
});
//# sourceMappingURL=ExpGlobalDomainOptions.js.map
